import request from "@/utils/request"

export function login(username,password) {
  return request({
    url: "/login",
    method: "POST",
    data: {
      username,
      password
    }
  })
}

export function logout() {
  return request({
    url: "/logout",
    method: "POST"
  })
}
